export default __webpack_public_path__ + "static/media/BoxBtnText.47bf48e0.png";